import { useTranslation } from 'react-i18next';

import SelectorLanguageComponent from '../../components/selector-language-component/selector-language-component';

export function LegalNotice() {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen pt-5"
      style={{
        background: 'linear-gradient(60deg, #13dfb6 0%,#004e78 100%)',
      }}
    >
      {/* Selector de idioma en la esquina superior */}
      <div className="absolute right-0 top-0">
        <div className="flex p-3 justify-content-end">
          <SelectorLanguageComponent />
        </div>
      </div>

      {/* Contenedor Principal */}
      <div className="flex justify-content-center pt-8 px-5 md:px-6 pb-5">
        <div className="w-full md:w-11 lg:w-9 xl:w-7 surface-100 shadow-2 text-center border-round-3xl relative p-4 md:p-5 ">
          {/* Logo */}
          <div className="col-12 text-center p-0">
            <img
              className="w-18rem lg:w-15rem"
              src="/assets/marsi-azul-degradado-fondo-blanco.webp"
              alt="Logotipo de Marsinet"
              rel="preload"
            />
          </div>

          {/* Contenido */}
          <div className="col-12 text-left px-3">
            {/* Aviso Legal */}
            <h1 className="text-4xl font-bold text-primary-500 text-center">
              <span className="text-900">
                {t('pages.register.legalNoticeTexts.legalNoticeTitle')}
              </span>
            </h1>
            <p className="text-justify text-700 mb-5">
              {t('pages.register.legalNoticeTexts.textLegalNotice')}
            </p>

            {/* Datos Identificativos */}
            <h2 className="text-xl font-bold text-900">
              {t('pages.register.legalNoticeTexts.identificationData')}
            </h2>
            <div className="surface-300 p-3 border-round-xl mb-5">
              <p className="text-justify text-700">
                {t('pages.register.legalNoticeTexts.text2IdentificationData')}
                <br />
                <strong>
                  {t('pages.register.legalNoticeTexts.companyName')}
                </strong>{' '}
                MARSI BIONICS S.L
                <br />
                <strong>
                  {t('pages.register.legalNoticeTexts.address')}
                </strong>{' '}
                Calle Marie Curie, 13, Planta 6, Edif. Bioma, Oficinas 1-2,
                28521 Rivas-Vaciamadrid, Madrid
                <br />
                <strong>
                  {t('pages.register.legalNoticeTexts.phone')}
                </strong>{' '}
                914900090
                <br />
                <strong>
                  {t('pages.register.legalNoticeTexts.email')}
                </strong>{' '}
                info@marsibionics.com
              </p>
            </div>

            {/* Reutilización de Bloques */}
            {[
              { title: 'usersTitle', text: 'usersText' },
              { title: 'usePortalTitle', text: 'usePortalText' },
              {
                title: 'intellectualPropertyTitle',
                text: 'intellectualPropertyText1',
              },
              {
                title: 'exclusionWarrantiesTitle',
                text: 'exclusionWarrantiesText1',
              },
              { title: 'modificationsTitle', text: 'modificationsText' },
              { title: 'rightOfExclusionTitle', text: 'rightOfExclusionText' },
              { title: 'generalTitle', text: 'generalText' },
              {
                title: 'applicableLegislationTitle',
                text: 'applicableLegislationText',
              },
            ].map((section, index) => (
              <div key={index} className="mb-5">
                <h2 className="text-xl font-bold text-900">
                  {t(`pages.register.legalNoticeTexts.${section.title}`)}
                </h2>
                <p className="text-justify text-700">
                  {t(`pages.register.legalNoticeTexts.${section.text}`)}
                </p>
              </div>
            ))}

            {/* Plataforma Europea */}
            <h2 className="text-xl font-bold text-900">
              {t('pages.register.legalNoticeTexts.europeanPlatformTitle')}
            </h2>
            <div className="p-4 bg-white border rounded-lg shadow-md">
              <p className="text-gray-700 mb-2">
                {t('pages.register.legalNoticeTexts.europeanPlatformText')}
                <br />
                <a
                  href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.show&lng=ES"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-500 hover:underline break-words"
                >
                  https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.show&lng=ES
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LegalNotice;
